import * as PIXI from "pixi.js"
import { config } from "./settings";

export const app = new PIXI.Application({
  width: config.originalWidth,
  height: config.originalHeight,
  backgroundColor: 0xFFFFFF,
  antialias: true,
  resolution: 2, //window.devicePixelRatio,
  backgroundAlpha: 0,
});
PIXI.settings.RENDER_OPTIONS.hello = false

